// Aclaraciones sobre qué acción de la interfaz corresponde a qué permiso, para los casos
// donde el nombre del botón no es Ver/Crear/Editar/Borrar/Exportar directamente pero
// funcionalmente dispara esa acción (ej. "Duplicar" en realidad requiere Crear). Se muestran
// en la pantalla de Permisos (src/views/pages/permissions/list/List.vue) como un popover
// anclado a un ícono, junto al nombre del módulo — no bloquean nada, son solo texto para
// quien configura los permisos. Se van agregando de a una, moduleKey -> array de notas.
const MODULE_ACTION_NOTES = {
  'privacy-treatment': [
    'El botón Duplicar se habilita si el usuario tiene habilitado Crear.',
  ],
  'privacy-gap': [
    'Gestionar catálogo de obligaciones se habilitará si el usuario tiene habilitado Editar.',
  ],
  'confirmations-daily': [
    'El usuario que tenga permiso para ver este módulo también tendrá acceso a Ver Evaluación. Dentro de esa vista podrá descargar el PDF si tiene habilitado Exportar y reevaluar si tiene habilitado Editar.',
  ],
  'case-management': [
    'El botón Finalizar se habilita si el usuario tiene habilitado Borrar.',
  ],
  risks: [
    'El botón Evaluar y el botón Historial del índice de riesgo se habilitan si el usuario tiene habilitado Ver.',
  ],
  calendar: [
    'Los botones: Sincronizar con Outlook y Nueva Evaluación se habilitan si el usuario tiene habilitado Crear.',
  ],
  'complaint-channel': [
    'El botón Finalizar se habilita si el usuario tiene habilitado Borrar.',
  ],
  'records-library': [
    'El botón Subir nueva versión se habilita si el usuario tiene habilitado Editar.',
    'Los botones Validar y Rechazar se habilitan si el usuario tiene habilitado Editar, o si es el responsable del registro mientras el documento está pendiente.',
    'El botón Desactivar se habilita si el usuario tiene habilitado Borrar.',
  ],
  'records-coi-collaborator': [
    'El botón Subir nueva versión se habilita si el usuario tiene habilitado Editar.',
    'Los botones Validar y Rechazar se habilitan si el usuario tiene habilitado Editar, o si es el responsable del registro mientras el documento está pendiente.',
    'El botón Desactivar se habilita si el usuario tiene habilitado Borrar.',
  ],
  'records-coi-supplier': [
    'El botón Subir nueva versión se habilita si el usuario tiene habilitado Editar.',
    'Los botones Validar y Rechazar se habilitan si el usuario tiene habilitado Editar, o si es el responsable del registro mientras el documento está pendiente.',
    'El botón Desactivar se habilita si el usuario tiene habilitado Borrar.',
  ],
  'records-lobby': [
    'El botón Subir nueva versión se habilita si el usuario tiene habilitado Editar.',
    'Los botones Validar y Rechazar se habilitan si el usuario tiene habilitado Editar, o si es el responsable del registro mientras el documento está pendiente.',
    'El botón Desactivar se habilita si el usuario tiene habilitado Borrar.',
  ],
}

export default MODULE_ACTION_NOTES
